import styled from 'styled-components'

import { theme } from 'styles/theme'

const BadgeText = styled.span<WithBadgeColor>`
  background-color: ${({ badgeColor }) => badgeColorToColor(badgeColor)};
  border-radius: ${theme.radii.large};
  padding: 0.3em 1.2em;

  /* Prevent stretching the badge when placed in a flexbox column, without setting align-items on the flexbox container, which prevents ellipsis. */
  inline-size: fit-content;
`

export enum BadgeColor {
  Normal,
  Green,
  Red,
  Grey,
  Orange,
}

function badgeColorToColor(badgeColor: BadgeColor): string {
  switch (badgeColor) {
    case BadgeColor.Normal:
      return theme.colors.MediumGrey
    case BadgeColor.Green:
      return theme.colors.LightGreen
    case BadgeColor.Red:
      return theme.colors.LightRed
    case BadgeColor.Grey:
      return theme.colors.LightGrey
    case BadgeColor.Orange:
      return theme.colors.AvatarColorOrange
  }
}

interface WithBadgeColor {
  badgeColor: BadgeColor
}

interface BadgeProps extends MaybeWithClassName, MaybeWithStyle, Partial<WithBadgeColor> {
  text: string
}

export const Badge = ({ text, badgeColor = BadgeColor.Normal, ...props }: BadgeProps) => {
  return <BadgeText {...{ badgeColor, ...props }}>{text}</BadgeText>
}

export const ToggledBadge = styled(Badge)<WithIsSelected>`
  display: flex;
  background-color: ${({ isSelected }) => (isSelected ? theme.colors.SecondaryYellow : theme.colors.Grey1)};
  border-color: ${({ isSelected }) => (isSelected ? theme.colors.SecondaryYellow : theme.colors.Gray8)};
  font-weight: ${({ isSelected }) => (isSelected ? 'bold' : 'regular')};
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  justify-content: left;
  user-select: none;
`

export const BadgeGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  align-items: center;
  justify-content: left;
  gap: 1em;
`
